import { Stack, Typography } from "@mui/material";
import { StepBarSection, StepDonutSection } from "../../../../../Users/usersApiMapping";
import UsersStepDonutSection from "../../../../../Users/StepSections/UsersStepDonutSection";
import UsersStepBarSection from "./UsersStepBarSection";
import UsersStepSkel from "./helpers/UsersStepSkel";

interface UsersStepSectionsProps {
  step1Section: StepBarSection | null;
  step2Section: StepBarSection | null;
  step3Section: StepBarSection | null;
  step4Section: StepBarSection | null;
  step5Section: StepDonutSection | null;
  step6Section: StepBarSection | null;
  step7Section: StepBarSection | null;
}

const STEP_TITLES = [
  "Step 1 - Borrow Amount",
  "Step 2 - Loan Purpose",
  "Step 3 - Time in Business",
  "Step 4 - Monthly Revenue",
  "Step 5 - Business Bank Account",
  "Step 6 - Business Industry",
  "Step 7 - Personal Credit",
];

// Mobile-only progressive-loading composition (Story 8: "prioritize loading
// the funnel and overview charts before progressively loading the remaining
// chart sections"). Each step section renders as soon as ITS OWN queries
// resolve, showing its own skeleton until then - unlike the desktop
// UsersStepSections.tsx, which the parent Users.tsx (mobile) does not reuse
// here because desktop waits for every step to be ready before rendering
// any of them (an all-or-nothing gate this progressive version replaces).
export default function UsersStepSections({
  step1Section,
  step2Section,
  step3Section,
  step4Section,
  step5Section,
  step6Section,
  step7Section,
}: UsersStepSectionsProps) {
  const sections: Array<StepBarSection | StepDonutSection | null> = [
    step1Section,
    step2Section,
    step3Section,
    step4Section,
    step5Section,
    step6Section,
    step7Section,
  ];

  return (
    <Stack spacing={4}>
      {sections.map((section, index) => (
        <Stack key={STEP_TITLES[index]} spacing={1.75}>
          <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#1a1a1a" }}>
            {section?.title ?? STEP_TITLES[index]}
          </Typography>
          {!section ? (
            <UsersStepSkel donut={index === 4} />
          ) : section.kind === "bar" ? (
            <UsersStepBarSection section={section} />
          ) : (
            <UsersStepDonutSection section={section} />
          )}
        </Stack>
      ))}
    </Stack>
  );
}
